export default __webpack_public_path__ + "static/media/flag-it.f091379c.svg";